function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useCurrentAccount } from "../../../hooks";
import { useAnnouncements } from "./useAnnouncements";
export var useIsReachingLimit = function() {
    var getCurrentLimits = useCurrentAccount().getCurrentLimits;
    var _getCurrentLimits = getCurrentLimits(), instances = _getCurrentLimits.instances, workspaces = _getCurrentLimits.workspaces;
    var hasAnnouncement = instances.reaching || workspaces.reaching;
    var actions = useAnnouncements("limits", hasAnnouncement);
    return _object_spread({
        hasAnnouncement: hasAnnouncement
    }, actions);
};

//# sourceMappingURL=useIsReachingLimit.js.map